<template lang="pug">
  .support-ctas.text-center
    a.support-cta.upper.semi-bold.color-slate.xs-f-small.max-at-tweak(v-if='checkVisibility("email")' href="/support?open=true" @click="doTrack('CC Email')")
      span.icon-email.cta-icon.color-white.xs-f-grande.max-at-tweak
      br
      | email
    button.support-cta.upper.semi-bold.color-slate.xs-f-small.max-at-tweak(v-if='checkVisibility("chat")' @click="onSelectChat()")
      span.icon-chat.cta-icon.color-white.xs-f-grande.max-at-tweak
      br
      | chat
    a.support-cta.upper.semi-bold.color-slate.xs-f-small.max-at-tweak(v-if='checkVisibility("phone")' :href="'tel:' + contactPhone" @click="doTrack('CC Call')")
      span.icon-phone.cta-icon.color-white.xs-f-grande.max-at-tweak
      br
      | call
  
</template>

<script>
  export default {
    name: "SupportCtas",
    props: {
      hideCtas: {
        type: Array,
        default: () => [],
        required: false
      },
      phoneNumber: {
        type: String,
        required: false
      },

      trackEventParams: {
        type: Object,
        required: false,
        default: null
      }
    },

    computed: {
      contactPhone() {
        return this.phoneNumber || this.$root.MRConfig.contactPhone;
      }
    },

    methods: {
      doTrack(name) {
        this.trackEvent(name, this.trackEventParams);
      },

      onSelectChat() {
        this.doTrack('CC Chat');
        if(window.zE && typeof window.zE == 'function') {
          window.zE('webWidget', 'open');
        } else {
          window.location.href = "/support";
        }
      },

      checkVisibility(icon) {
        return !this.hideCtas.includes(icon);
      }
    }
   }
</script>

<style scoped lang="stylus">
  .support-ctas
    a
      &:hover
        color color-slate

    .support-cta
      display inline-block
      vertical-align top
      padding 0 0.5em
      margin 0 2%
      background-color transparent
      border none

      &:focus
        outline -webkit-focus-ring-color auto 5px

      .cta-icon
        display inline-block
        vertical-align top
        background-color color-mr-blue
        border-radius 50%
        padding 0.375em
        margin-bottom 0.25em
        transition all .4s

        &:hover
          background-color color-mr-deepblue

        &:before
          display block
          margin 0
          width 1em
          height 1em
</style>
